import Section from "../Section";
import Swiper from 'swiper';

export default class InfoColumns extends Section {
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

    const nextEl = this.element.querySelector('.swiper-button--next');
    const prevEl = this.element.querySelector('.swiper-button--prev');
    const swiperContainer = this.element.querySelector('.swiper-container');
    const slidesPerView = parseInt(this.element.dataset.slidesPerRow);
    this.swiper = new Swiper(swiperContainer, {
      slidesPerView: 1,
      allowTouchMove: true,
      navigation: {
        nextEl,
        prevEl,
      },
      breakpoints: {
        // when window width is >= 768px
        768: {
          slidesPerView: slidesPerView,
        },
      },
      watchOverflow: true,
      autoHeight: true,
      loop: true,
      pagination: {
        el: this.element.parentNode.querySelector('.swiper-pagination'),
        type: 'bullets',
        clickable: true,
        renderBullet: (index, className) => {
          return '<span class="' + className + '"><span class="swiper-pagination-bullet-dot"></span></span>';
        },
      },
    });
  }

  onBlockSelect = ({ element }) => {
    const index = parseInt(element.dataset.slideIndex, 10);
    const transitionDuration = 300; // Transition duration (ms) – 300 is the default value
    this.swiper.slideTo(index, transitionDuration, false)
  }
}
